module.exports = __webpack_public_path__ + "img/slide-3-1.a24fc1cf.jpg";